import { Box, Flex, Text } from '@modusign/design-system';
import { LabelWithBookmarkResponse } from '@modusign/openapi-client-category/generated/model';

import { UseSelectionMapReturn } from '@hooks';

import IconLabel from '@app/features/label/components/IconLabel';
import {
  LabelingState,
  LabelsLabelingState,
} from '@app/features/label/components/LabelPopovers/context/types';
import LabelCheckListItem from '@app/features/label/components/LabelPopovers/LabelApplyPopover/LabelCheckList/LabelCheckListItem';
import { LabelFilters } from '@app/features/label/types';
import { MAX_COUNT_OF_LABELS_PER_RESOURCE } from '@app/features/workspaceManagement/constants';

import LabelListItem from '../../components/LabelListItem';

interface LabelCheckListProps {
  initialLabeled: LabelsLabelingState;
  selected: UseSelectionMapReturn<LabelingState>;
  labels: LabelWithBookmarkResponse[];
  filters: LabelFilters;
}

function LabelCheckList({
  initialLabeled,
  selected: { map, entries, toggle },
  labels,
  filters,
}: LabelCheckListProps) {
  const sorted = labels.sort((a, b) => {
    const isALabeled = !!initialLabeled?.[a.id];
    const isBLabeled = !!initialLabeled?.[b.id];

    if (isALabeled === isBLabeled) {
      return 0;
    }
    return isALabeled ? -1 : 1;
  });

  return (
    <Flex as="section" flexDirection="column" maxHeight="300px" overflowY="scroll" py={4}>
      {sorted.map((label) => (
        <LabelListItem
          active={(initialLabeled[label.id] ?? 'NONE') !== (map.get(label.id) ?? 'NONE')}
          key={label.id}
          label={label}
        >
          <LabelCheckListItem
            checked={map.get(label.id) ?? 'NONE'}
            disableMessage={
              !entries.filter(([, v]) => v !== 'NONE').some(([k]) => k === label.id) &&
              entries.filter(([, v]) => v !== 'NONE').length >= MAX_COUNT_OF_LABELS_PER_RESOURCE &&
              `최대 ${MAX_COUNT_OF_LABELS_PER_RESOURCE}개의 라벨만 적용할 수 있습니다.`
            }
            onCheck={(checked) => {
              toggle([[label.id, checked]]);
            }}
          >
            <Box width="100%">
              <IconLabel bookmarked={!!label.bookmark} name={`${label.name}`} />
            </Box>
          </LabelCheckListItem>
        </LabelListItem>
      ))}
      {labels.length === 0 && (
        <Text m={4} textAlign="center">
          {filters?.name ? (
            <>
              <Text fontWeight="medium">{`'${filters?.name}' `}</Text>
              검색 결과가 없습니다.
            </>
          ) : (
            '새 라벨을 추가해 문서를 분류해 보세요.'
          )}
        </Text>
      )}
    </Flex>
  );
}

export default LabelCheckList;
